import { render, staticRenderFns } from "./ModalBinderIndex.vue?vue&type=template&id=0e6c8475&"
import script from "./ModalBinderIndex.vue?vue&type=script&lang=js&"
export * from "./ModalBinderIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports